var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      staticClass: "page",
      attrs: { title: _vm.$t("Webheader.rtp_global_settings"), colWidth: "6" },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _vm.activateSpinner
            ? _c("spinner")
            : _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "ml-2 mt-xl-0" },
                    [
                      _c(
                        "b-button-group",
                        {},
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: _vm.tabName === 0 ? "primary" : "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.tabName = 0
                                  _vm.resetSettings()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("settings.global_label")))]
                          ),
                          _vm._v(" "),
                          _vm.canSeeSRTP
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: _vm.tabName === 1 ? "primary" : "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.tabName = 1
                                      _vm.resetSettings()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("settings.eba_label")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canSeeHRTP
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: _vm.tabName === 2 ? "primary" : "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.tabName = 2
                                      _vm.resetSettings()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("settings.giro_label")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canSeePSD2
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: _vm.tabName === 3 ? "primary" : "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.tabName = 3
                                      _vm.resetSettings()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.norm.psd2")))]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tabs",
                    {
                      staticClass: "mt-3",
                      attrs: { "nav-class": "d-none" },
                      model: {
                        value: _vm.tabName,
                        callback: function ($$v) {
                          _vm.tabName = $$v
                        },
                        expression: "tabName",
                      },
                    },
                    [
                      _c(
                        "b-tab",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { cols: "12", lg: "10", offset: "1" },
                                },
                                [
                                  _c("form-write-group-label-input", {
                                    key: "maxLine" + _vm.resetInput,
                                    attrs: {
                                      disabled: !_vm.doesEdit,
                                      maxLength: 21,
                                      inputType: "number",
                                      inputLabel: _vm.$t(
                                        "settings.max_lines_export"
                                      ),
                                      horizontal: "",
                                    },
                                    on: { input: _vm.changeMaxLinesExportRTP },
                                    model: {
                                      value: _vm.settings["RTPMaxLinesExport"],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.settings,
                                          "RTPMaxLinesExport",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "settings['RTPMaxLinesExport']",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { cols: "12", lg: "10", offset: "1" },
                                },
                                [
                                  _c(
                                    "form-write-group-label-input",
                                    {
                                      key: "environment" + _vm.resetInput,
                                      attrs: {
                                        inputType: "other",
                                        inputClass: "inputParentFormWriteGroup",
                                        inputLabel: _vm.$t(
                                          "settings.environnment_type"
                                        ),
                                        horizontal: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.settings["Environment"],
                                              expression:
                                                "settings['Environment']",
                                            },
                                          ],
                                          staticClass:
                                            "form-control pr-5 col-7",
                                          attrs: { disabled: !_vm.doesEdit },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.settings,
                                                "Environment",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        _vm._l(
                                          _vm.environnments,
                                          function (env, index) {
                                            return _c(
                                              "option",
                                              {
                                                key: env.name + "-" + index,
                                                domProps: { value: env.value },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "settings." + env.name
                                                    )
                                                  )
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        [
                          _c(
                            "form-accordion",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                title: _vm.$t("settings.general_sttngs"),
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          disabled: !_vm.doesEdit,
                                          inputType: "text",
                                          inputLabel: _vm.$t(
                                            "administration.rtp_identifier"
                                          ),
                                          horizontal: "",
                                        },
                                        model: {
                                          value: _vm.settings.RTPSPIdentifier,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.settings,
                                              "RTPSPIdentifier",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "settings.RTPSPIdentifier",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "form-write-group-label-input",
                                        {
                                          attrs: {
                                            disabled: !_vm.doesEdit,
                                            inputType: "other",
                                            inputLabel: _vm.$t(
                                              "administration.rtp_api_accountvalidation"
                                            ),
                                            horizontal: "",
                                          },
                                          model: {
                                            value:
                                              _vm.settings[
                                                "SRTP-API-AccountValidation"
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.settings,
                                                "SRTP-API-AccountValidation",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "settings['SRTP-API-AccountValidation']",
                                          },
                                        },
                                        [
                                          _c("b-form-checkbox", {
                                            attrs: {
                                              value: "1",
                                              "unchecked-value": "0",
                                              disabled: !_vm.doesEdit,
                                            },
                                            model: {
                                              value:
                                                _vm.settings[
                                                  "SRTP-API-AccountValidation"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.settings,
                                                  "SRTP-API-AccountValidation",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "settings['SRTP-API-AccountValidation']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c("form-write-group-label-input", {
                                        key: "srtpMaxAmount" + _vm.resetInput,
                                        staticClass: "justify-content-around",
                                        attrs: {
                                          disabled: !_vm.doesEdit,
                                          maxLength: 21,
                                          inputType: "number",
                                          inputLabel: _vm.$t(
                                            "settings.max_amnt_srtp"
                                          ),
                                          horizontal: "",
                                        },
                                        on: {
                                          input: _vm.controlMaxAmountSRTP,
                                          blur: _vm.changeMaxAmountSRTP,
                                        },
                                        model: {
                                          value:
                                            _vm.settings["SRTP-RTPSPMaxAmount"],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.settings,
                                              "SRTP-RTPSPMaxAmount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "settings['SRTP-RTPSPMaxAmount']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c("form-write-group-label-input", {
                                        key: "SRTPExp" + _vm.resetInput,
                                        attrs: {
                                          disabled: !_vm.doesEdit,
                                          maxLength: 21,
                                          inputType: "number",
                                          inputLabel: _vm.$t(
                                            "administration.rtp_time_before_expiration"
                                          ),
                                          horizontal: "",
                                        },
                                        on: {
                                          input: _vm.controlTimeBeforeExpSRTP,
                                          blur: _vm.changeTimeBeforeExpSRTP,
                                        },
                                        model: {
                                          value:
                                            _vm.settings
                                              .RTPSPTimeBeforeExpiration,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.settings,
                                              "RTPSPTimeBeforeExpiration",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "settings.RTPSPTimeBeforeExpiration",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                title: _vm.$t("settings.archive"),
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-bottom",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-end",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.srtp_archive_freq"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "srtpArchFrqY" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.year"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.srtpArchiveFrequenceYear,
                                                    callback: function ($$v) {
                                                      _vm.srtpArchiveFrequenceYear =
                                                        $$v
                                                    },
                                                    expression:
                                                      "srtpArchiveFrequenceYear",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "srtpArchFrqM" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.month"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.srtpArchiveFrequenceMonth,
                                                    callback: function ($$v) {
                                                      _vm.srtpArchiveFrequenceMonth =
                                                        $$v
                                                    },
                                                    expression:
                                                      "srtpArchiveFrequenceMonth",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "srtpArchFrqD" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.day"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.srtpArchiveFrequenceDay,
                                                    callback: function ($$v) {
                                                      _vm.srtpArchiveFrequenceDay =
                                                        $$v
                                                    },
                                                    expression:
                                                      "srtpArchiveFrequenceDay",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-bottom",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-end",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.srtp_archive_delay"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "srtpArchDelY" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.year"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.srtpArchiveDelayYear,
                                                    callback: function ($$v) {
                                                      _vm.srtpArchiveDelayYear =
                                                        $$v
                                                    },
                                                    expression:
                                                      "srtpArchiveDelayYear",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "srtpArchDelM" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.month"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.srtpArchiveDelayMonth,
                                                    callback: function ($$v) {
                                                      _vm.srtpArchiveDelayMonth =
                                                        $$v
                                                    },
                                                    expression:
                                                      "srtpArchiveDelayMonth",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "srtpArchDelD" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.day"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.srtpArchiveDelayDay,
                                                    callback: function ($$v) {
                                                      _vm.srtpArchiveDelayDay =
                                                        $$v
                                                    },
                                                    expression:
                                                      "srtpArchiveDelayDay",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c("form-read-group-label-input", {
                                        staticClass: "justify-content-around",
                                        attrs: {
                                          inputValue: _vm.srtpLastArchive,
                                          maxLength: 21,
                                          inputType: "text",
                                          inputLabel: _vm.$t(
                                            "settings.srtp_last_archive"
                                          ),
                                          horizontal: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                title: _vm.$t("settings.purge"),
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-bottom",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-end",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.srtp_purge_freq"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "srtpPurgFrqY" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.year"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.srtpPurgeFrequenceYear,
                                                    callback: function ($$v) {
                                                      _vm.srtpPurgeFrequenceYear =
                                                        $$v
                                                    },
                                                    expression:
                                                      "srtpPurgeFrequenceYear",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "srtpPurgFrqM" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.month"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.srtpPurgeFrequenceMonth,
                                                    callback: function ($$v) {
                                                      _vm.srtpPurgeFrequenceMonth =
                                                        $$v
                                                    },
                                                    expression:
                                                      "srtpPurgeFrequenceMonth",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "srtpPurgFrqD" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.day"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.srtpPurgeFrequenceDay,
                                                    callback: function ($$v) {
                                                      _vm.srtpPurgeFrequenceDay =
                                                        $$v
                                                    },
                                                    expression:
                                                      "srtpPurgeFrequenceDay",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-bottom",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-end",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.srtp_purge_delay"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "srtpPurDelqY" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.year"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.srtpPurgeDelayYear,
                                                    callback: function ($$v) {
                                                      _vm.srtpPurgeDelayYear =
                                                        $$v
                                                    },
                                                    expression:
                                                      "srtpPurgeDelayYear",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "srtpPurDelqM" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.month"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.srtpPurgeDelayMonth,
                                                    callback: function ($$v) {
                                                      _vm.srtpPurgeDelayMonth =
                                                        $$v
                                                    },
                                                    expression:
                                                      "srtpPurgeDelayMonth",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "srtpPurDelqD" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.day"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.srtpPurgeDelayDay,
                                                    callback: function ($$v) {
                                                      _vm.srtpPurgeDelayDay =
                                                        $$v
                                                    },
                                                    expression:
                                                      "srtpPurgeDelayDay",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c("form-read-group-label-input", {
                                        staticClass: "justify-content-around",
                                        attrs: {
                                          inputValue: _vm.srtpLastPurge,
                                          maxLength: 21,
                                          inputType: "text",
                                          inputLabel: _vm.$t(
                                            "settings.srtp_last_purge"
                                          ),
                                          horizontal: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        [
                          _c(
                            "form-accordion",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                title: _vm.$t("settings.general_sttngs"),
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          disabled: !_vm.doesEdit,
                                          inputType: "text",
                                          inputLabel: _vm.$t(
                                            "administration.hrtp_identifier"
                                          ),
                                          horizontal: "",
                                        },
                                        model: {
                                          value:
                                            _vm.settings["HRTP-Identifier"],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.settings,
                                              "HRTP-Identifier",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "settings['HRTP-Identifier']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "form-write-group-label-input",
                                        {
                                          attrs: {
                                            disabled: !_vm.doesEdit,
                                            inputType: "other",
                                            inputLabel: _vm.$t(
                                              "administration.hrtp_api_accountvalidation"
                                            ),
                                            horizontal: "",
                                          },
                                          model: {
                                            value:
                                              _vm.settings[
                                                "HRTP-API-AccountValidation"
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.settings,
                                                "HRTP-API-AccountValidation",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "settings['HRTP-API-AccountValidation']",
                                          },
                                        },
                                        [
                                          _c("b-form-checkbox", {
                                            attrs: {
                                              value: "1",
                                              "unchecked-value": "0",
                                              disabled: !_vm.doesEdit,
                                            },
                                            model: {
                                              value:
                                                _vm.settings[
                                                  "HRTP-API-AccountValidation"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.settings,
                                                  "HRTP-API-AccountValidation",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "settings['HRTP-API-AccountValidation']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c("form-write-group-label-input", {
                                        key: "hrtpMaxAmount" + _vm.resetInput,
                                        staticClass: "justify-content-around",
                                        attrs: {
                                          disabled: !_vm.doesEdit,
                                          maxLength: 21,
                                          inputType: "number",
                                          inputLabel: _vm.$t(
                                            "settings.max_amnt_hrtp"
                                          ),
                                          horizontal: "",
                                        },
                                        on: {
                                          input: _vm.controlMaxAmountHRTP,
                                          blur: _vm.changeMaxAmountHRTP,
                                        },
                                        model: {
                                          value:
                                            _vm.settings["HRTP-RTPSPMaxAmount"],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.settings,
                                              "HRTP-RTPSPMaxAmount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "settings['HRTP-RTPSPMaxAmount']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c("form-write-group-label-input", {
                                        key: "hrtpExp" + _vm.resetInput,
                                        attrs: {
                                          disabled: !_vm.doesEdit,
                                          maxLength: 21,
                                          inputType: "number",
                                          inputLabel: _vm.$t(
                                            "administration.rtp_h_validity_period"
                                          ),
                                          horizontal: "",
                                        },
                                        on: {
                                          input: _vm.controlTimeBeforeExpHRTP,
                                          blur: _vm.changeVldityPeriodHRTP,
                                        },
                                        model: {
                                          value:
                                            _vm.settings["HRTP-ValidityPeriod"],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.settings,
                                              "HRTP-ValidityPeriod",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "settings['HRTP-ValidityPeriod']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                title: _vm.$t("settings.archive"),
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-bottom",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-end",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.hrtp_archive_freq"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "hrtpArchFrqY" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.year"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.hrtpArchiveFrequenceYear,
                                                    callback: function ($$v) {
                                                      _vm.hrtpArchiveFrequenceYear =
                                                        $$v
                                                    },
                                                    expression:
                                                      "hrtpArchiveFrequenceYear",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "hrtpArchFrqM" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.month"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.hrtpArchiveFrequenceMonth,
                                                    callback: function ($$v) {
                                                      _vm.hrtpArchiveFrequenceMonth =
                                                        $$v
                                                    },
                                                    expression:
                                                      "hrtpArchiveFrequenceMonth",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "hrtpArchFrqD" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.day"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.hrtpArchiveFrequenceDay,
                                                    callback: function ($$v) {
                                                      _vm.hrtpArchiveFrequenceDay =
                                                        $$v
                                                    },
                                                    expression:
                                                      "hrtpArchiveFrequenceDay",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-bottom",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-end",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.hrtp_archive_delay"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "hrtpArchDelY" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.year"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.hrtpArchiveDelayYear,
                                                    callback: function ($$v) {
                                                      _vm.hrtpArchiveDelayYear =
                                                        $$v
                                                    },
                                                    expression:
                                                      "hrtpArchiveDelayYear",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "hrtpArchDelM" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.month"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.hrtpArchiveDelayMonth,
                                                    callback: function ($$v) {
                                                      _vm.hrtpArchiveDelayMonth =
                                                        $$v
                                                    },
                                                    expression:
                                                      "hrtpArchiveDelayMonth",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "hrtpArchDelD" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.day"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.hrtpArchiveDelayDay,
                                                    callback: function ($$v) {
                                                      _vm.hrtpArchiveDelayDay =
                                                        $$v
                                                    },
                                                    expression:
                                                      "hrtpArchiveDelayDay",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c("form-read-group-label-input", {
                                        staticClass: "justify-content-around",
                                        attrs: {
                                          inputValue: _vm.hrtpLastArchive,
                                          maxLength: 21,
                                          inputType: "text",
                                          inputLabel: _vm.$t(
                                            "settings.hrtp_last_archive"
                                          ),
                                          horizontal: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                title: _vm.$t("settings.purge"),
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-bottom",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-end",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.hrtp_purge_freq"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "hrtpPurgFrqY" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.year"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.hrtpPurgeFrequenceYear,
                                                    callback: function ($$v) {
                                                      _vm.hrtpPurgeFrequenceYear =
                                                        $$v
                                                    },
                                                    expression:
                                                      "hrtpPurgeFrequenceYear",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "hrtpPurgFrqM" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.month"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.hrtpPurgeFrequenceMonth,
                                                    callback: function ($$v) {
                                                      _vm.hrtpPurgeFrequenceMonth =
                                                        $$v
                                                    },
                                                    expression:
                                                      "hrtpPurgeFrequenceMonth",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "hrtpPurgFrqD" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.day"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.hrtpPurgeFrequenceDay,
                                                    callback: function ($$v) {
                                                      _vm.hrtpPurgeFrequenceDay =
                                                        $$v
                                                    },
                                                    expression:
                                                      "hrtpPurgeFrequenceDay",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-bottom",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-end",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.hrtp_purge_delay"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "hrtpPurgDelY" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.year"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.hrtpPurgeDelayYear,
                                                    callback: function ($$v) {
                                                      _vm.hrtpPurgeDelayYear =
                                                        $$v
                                                    },
                                                    expression:
                                                      "hrtpPurgeDelayYear",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "hrtpPurgDelM" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.month"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.hrtpPurgeDelayMonth,
                                                    callback: function ($$v) {
                                                      _vm.hrtpPurgeDelayMonth =
                                                        $$v
                                                    },
                                                    expression:
                                                      "hrtpPurgeDelayMonth",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "hrtpPurgDelD" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.day"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.hrtpPurgeDelayDay,
                                                    callback: function ($$v) {
                                                      _vm.hrtpPurgeDelayDay =
                                                        $$v
                                                    },
                                                    expression:
                                                      "hrtpPurgeDelayDay",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c("form-read-group-label-input", {
                                        staticClass: "justify-content-around",
                                        attrs: {
                                          inputValue: _vm.hrtpLastPurge,
                                          maxLength: 21,
                                          inputType: "text",
                                          inputLabel: _vm.$t(
                                            "settings.hrtp_last_purge"
                                          ),
                                          horizontal: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { cols: "12", lg: "10", offset: "1" },
                                },
                                [
                                  _c("form-write-group-label-input", {
                                    key: "psd2tokenioredirect" + _vm.resetInput,
                                    attrs: {
                                      disabled: !_vm.doesEdit,
                                      inputType: "text",
                                      inputLabel: _vm.$t(
                                        "settings.tokenio_redirecturl"
                                      ),
                                      horizontal: "",
                                    },
                                    model: {
                                      value:
                                        _vm.settings[
                                          "PSD2-Token.io-RedirectURL"
                                        ],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.settings,
                                          "PSD2-Token.io-RedirectURL",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "settings['PSD2-Token.io-RedirectURL']",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                title: _vm.$t("settings.archive"),
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-bottom",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-end",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.psd2_archive_freq"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "psd2ArchFrqY" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.year"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.psd2ArchiveFrequenceYear,
                                                    callback: function ($$v) {
                                                      _vm.psd2ArchiveFrequenceYear =
                                                        $$v
                                                    },
                                                    expression:
                                                      "psd2ArchiveFrequenceYear",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "psd2ArchFrqM" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.month"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.psd2ArchiveFrequenceMonth,
                                                    callback: function ($$v) {
                                                      _vm.psd2ArchiveFrequenceMonth =
                                                        $$v
                                                    },
                                                    expression:
                                                      "psd2ArchiveFrequenceMonth",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "psd2ArchFrqD" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.day"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.psd2ArchiveFrequenceDay,
                                                    callback: function ($$v) {
                                                      _vm.psd2ArchiveFrequenceDay =
                                                        $$v
                                                    },
                                                    expression:
                                                      "psd2ArchiveFrequenceDay",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-bottom",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-end",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.psd2_archive_delay"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "psd2ArchDelY" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.year"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.psd2ArchiveDelayYear,
                                                    callback: function ($$v) {
                                                      _vm.psd2ArchiveDelayYear =
                                                        $$v
                                                    },
                                                    expression:
                                                      "psd2ArchiveDelayYear",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "psd2ArchDelM" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.month"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.psd2ArchiveDelayMonth,
                                                    callback: function ($$v) {
                                                      _vm.psd2ArchiveDelayMonth =
                                                        $$v
                                                    },
                                                    expression:
                                                      "psd2ArchiveDelayMonth",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "psd2ArchDelD" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.day"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.psd2ArchiveDelayDay,
                                                    callback: function ($$v) {
                                                      _vm.psd2ArchiveDelayDay =
                                                        $$v
                                                    },
                                                    expression:
                                                      "psd2ArchiveDelayDay",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c("form-read-group-label-input", {
                                        staticClass: "justify-content-around",
                                        attrs: {
                                          inputValue: _vm.psd2LastArchive,
                                          maxLength: 21,
                                          inputType: "text",
                                          inputLabel: _vm.$t(
                                            "settings.psd2_last_archive"
                                          ),
                                          horizontal: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                title: _vm.$t("settings.purge"),
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-bottom",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-end",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.psd2_purge_freq"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "psd2PurgFrqY" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.year"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.psd2PurgeFrequenceYear,
                                                    callback: function ($$v) {
                                                      _vm.psd2PurgeFrequenceYear =
                                                        $$v
                                                    },
                                                    expression:
                                                      "psd2PurgeFrequenceYear",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "psd2PurgFrqM" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.month"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.psd2PurgeFrequenceMonth,
                                                    callback: function ($$v) {
                                                      _vm.psd2PurgeFrequenceMonth =
                                                        $$v
                                                    },
                                                    expression:
                                                      "psd2PurgeFrequenceMonth",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "psd2PurgFrqD" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.day"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.psd2PurgeFrequenceDay,
                                                    callback: function ($$v) {
                                                      _vm.psd2PurgeFrequenceDay =
                                                        $$v
                                                    },
                                                    expression:
                                                      "psd2PurgeFrequenceDay",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-around d-flex justify-content-between align-items-bottom",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "col-5 d-flex align-items-end",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.psd2_purge_delay"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex col-7" },
                                            [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "psd2PurgDelY" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.year"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.psd2PurgeDelayYear,
                                                    callback: function ($$v) {
                                                      _vm.psd2PurgeDelayYear =
                                                        $$v
                                                    },
                                                    expression:
                                                      "psd2PurgeDelayYear",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "psd2PurgDelM" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.month"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.psd2PurgeDelayMonth,
                                                    callback: function ($$v) {
                                                      _vm.psd2PurgeDelayMonth =
                                                        $$v
                                                    },
                                                    expression:
                                                      "psd2PurgeDelayMonth",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  key:
                                                    "psd2PurgDelD" +
                                                    _vm.resetInput,
                                                  staticClass:
                                                    "justify-content-around",
                                                  attrs: {
                                                    disabled: !_vm.doesEdit,
                                                    maxLength: 21,
                                                    inputType: "number",
                                                    inputLabel:
                                                      _vm.$t("common.day"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.psd2PurgeDelayDay,
                                                    callback: function ($$v) {
                                                      _vm.psd2PurgeDelayDay =
                                                        $$v
                                                    },
                                                    expression:
                                                      "psd2PurgeDelayDay",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        cols: "12",
                                        lg: "10",
                                        offset: "1",
                                      },
                                    },
                                    [
                                      _c("form-read-group-label-input", {
                                        staticClass: "justify-content-around",
                                        attrs: {
                                          inputValue: _vm.psd2LastPurge,
                                          maxLength: 21,
                                          inputType: "text",
                                          inputLabel: _vm.$t(
                                            "settings.psd2_last_purge"
                                          ),
                                          horizontal: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
          _vm._v(" "),
          _vm.hasRight("application_global_rtp_settings_editer")
            ? _c(
                "div",
                { staticClass: "col-md-10 offset-md-1" },
                [
                  !_vm.doesEdit
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-end no-gutters" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: { click: _vm.editSettings },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("administration.edit"))),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "b-row",
                        { staticClass: "justify-content-end no-gutters" },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: { click: _vm.resetSettings },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("common.cncl"))),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pl-3" },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateSettings(_vm.settings)
                                    },
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("common.update"))),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }